import React from "react";

const CartIcon = () => {
  return (
    <svg
      width="29"
      height="20"
      viewBox="0 0 29 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path
          d="M9 5.06s2.086 7.41 3.13 7.41c1.043 0 10.43 1.06 10.43 1.06l3.13-3.177s1.044-2.118 1.044-3.177C26.734 6.118 27.777 4 27.777 4H9v1.06z"
          fill="#A3D9CB"
        />
        <path
          d="M1.68 1.575h5.664l3.57 9.69c.352 1.116 2.19 1.862 3.247 1.862h7.926c.916 0 1.758-.562 2.194-1.465l3.453-7.145a.436.436 0 0 0-.392-.625H8.467"
          stroke="#36455A"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <path
          d="M11.963 18.03a1.87 1.87 0 1 1 3.737 0 1.87 1.87 0 0 1-3.737 0zM19.73 18.03a1.87 1.87 0 1 1 3.738 0 1.87 1.87 0 0 1-3.737 0z"
          fill="#36455A"
        />
      </g>
    </svg>
  );
};

export default CartIcon;
